const comments = [
  {
    id: 1,
    name: '影视迷小张',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20portrait%20avatar%2C%20warm%20lighting%2C%20neutral%20expression%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20no%20text&width=120&height=120&seq=avatar-01&orientation=squarish',
    time: '2 小时前',
    content: '最近在成全影视追完了繁花，画质真的绝了，1080P流畅不卡顿！而且完全免费，没有广告弹窗，比那些要充会员的平台强太多了。强烈推荐给喜欢追剧的朋友们。',
    likes: 1286,
    watched: '繁花',
  },
  {
    id: 2,
    name: '电影发烧友阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20portrait%20avatar%20with%20glasses%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20no%20text&width=120&height=120&seq=avatar-02&orientation=squarish',
    time: '5 小时前',
    content: '国产科幻越来越好了！流浪地球3在成全影视上有4K修复版，效果震撼。更新速度也快，基本上院线下映没多久就能在这里看到高清版本，真心点赞。',
    likes: 967,
    watched: '流浪地球3',
  },
  {
    id: 3,
    name: '追剧小能手',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20portrait%20avatar%20of%20a%20young%20person%2C%20warm%20lighting%2C%20smiling%20expression%2C%20clean%20background%2C%20casual%20style%2C%20no%20text&width=120&height=120&seq=avatar-03&orientation=squarish',
    time: '昨天 22:30',
    content: '找到成全影视真的太开心了！庆余年2全集都有，弹幕功能也很有趣，边看剧边和网友互动。移动端适配做得很好，上下班路上用手机追剧特别方便，流量消耗也不大。',
    likes: 2034,
    watched: '庆余年2',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            观众热评
          </h2>
          <p className="text-sm text-foreground-500 mt-1">真实用户观影反馈，共享追剧快乐</p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-6">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground-800 whitespace-nowrap">{comment.name}</p>
                  <p className="text-xs text-foreground-500 whitespace-nowrap">{comment.time} · 看过《{comment.watched}》</p>
                </div>
                <div className="flex items-center gap-1 text-accent-500">
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                </div>
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-4">
                "{comment.content}"
              </p>

              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <button className="inline-flex items-center gap-1 hover:text-primary-500 cursor-pointer transition-colors whitespace-nowrap">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes.toLocaleString()}
                </button>
                <button className="inline-flex items-center gap-1 hover:text-primary-500 cursor-pointer transition-colors whitespace-nowrap">
                  <i className="ri-chat-1-line"></i>
                  回复
                </button>
                <button className="inline-flex items-center gap-1 hover:text-primary-500 cursor-pointer transition-colors whitespace-nowrap">
                  <i className="ri-share-forward-line"></i>
                  分享
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}